import api from "../../index";

export const GetOrganizerReportApi = (data) => api.post('organizer-report', data);
export const ExportOrganizerApi = (data,headers) => api.post('export-organizer', data,headers);
export const GetAuditReportApi = (data) => api.post('organizer-audit-trail', data);
export const GetAllAuditReportApi = () => api.post('all-organizer-audit-trail-report');
export const GetActiveJobReportApi = (data) => api.post('active-job-report', data);
export const GetCompleteJobReportApi = (data) => api.post('complate-by-emp-report', data);
export const GetOverdueTaskReportApi = (data) => api.post('overdue-task-report', data);
export const GetReferralReportApi = (data) => api.post('referral-report', data);
export const GetPaymentReportApi = (data) => api.post('payment-report', data);
